import React from 'react';
import CompaniesCard from './CompaniesCard';
import MainLayout from '../../layouts/MainLayout';

function Companies() {
  return (
    <MainLayout>
      <CompaniesCard />
    </MainLayout>
  );
}

export default Companies;
